import { sileo, Toaster } from "sileo";
import "sileo/styles.css";

// Componente reutilizable: se monta UNA sola vez en la raíz de la app
// (igual que <NotificationContainer /> en PlataformaClickPlus.js).
export const SileoToaster = (props) => <Toaster position="top-right" {...props} />;

// Despachador genérico: tipo = "success" | "error" | "warning" | "info" | "action" | "show"
export const NotificacionSileo = (tipo, titulo, descripcion, opciones = {}) => {
  const fn = sileo[tipo] || sileo.show;
  return fn({ title: titulo, description: descripcion, ...opciones });
};

export const SileoExito = (titulo, descripcion, opciones) => NotificacionSileo("success", titulo, descripcion, opciones);
export const SileoError = (titulo, descripcion, opciones) => NotificacionSileo("error", titulo, descripcion, opciones);
export const SileoAdvertencia = (titulo, descripcion, opciones) => NotificacionSileo("warning", titulo, descripcion, opciones);
export const SileoInfo = (titulo, descripcion, opciones) => NotificacionSileo("info", titulo, descripcion, opciones);

// opciones.button = { title, onClick }
export const SileoAccion = (titulo, descripcion, button, opciones = {}) =>
  NotificacionSileo("action", titulo, descripcion, { button, ...opciones });

// mensajes = { loading: SileoOptions, success: SileoOptions | (data)=>SileoOptions, error: SileoOptions | (err)=>SileoOptions }
export const SileoPromesa = (promise, mensajes) => sileo.promise(promise, mensajes);

export const SileoDismiss = (id) => sileo.dismiss(id);
export const SileoLimpiar = (position) => sileo.clear(position);
